import {Injectable} from '@angular/core';

import {PermissionService} from '../main/common/services/permission.service';

@Injectable({
    providedIn: 'root'
})
export class MenuPermission {
    menu: any;

    constructor(private _permissionService: PermissionService) {
    }

    getMenu() {
        this.menu = [
            {
                id: 'dashboard',
                title: 'Dashboard',
                translate: 'MENU.DASHBOARD',
                type: 'item',
                icon: '',
                newIcon: 'icon_home',
                heightIcon: 25,
                url: 'dashboard'
            },
            {
                id: 'consignmentNotes-index',
                translate: 'MENU.CONSIGNMENT_NOTES',
                title: 'Documentación',
                type: 'item',
                icon: '',
                newIcon: 'icon_consignment_note',
                url: 'consignmentNotes/index',
                hidden: !this._permissionService.checkPermission({name: 'consignmentNote.consignmentNotes.read'})
            },
            {
                id: 'informations',
                title: 'Informes',
                translate: 'MENU.INFORMATIONS',
                type: 'collapsible',
                icon: '',
                newIcon: 'icon_information',
                hidden: (!this._permissionService.checkPermission({name: 'information.informations.read'})
                    && !this._permissionService.checkPermission({name: 'information.informationBlocks.read'})),
                children: [
                    {
                        id: 'informations-index',
                        title: 'Informes',
                        translate: 'MENU.INFORMATIONS',
                        type: 'item',
                        icon: 'minus',
                        url: 'informations/index'
                    },
                    {
                        id: 'informationBlocks-index',
                        title: 'Bloque de Informes',
                        translate: 'MENU.INFORMATION_BLOCKS',
                        type: 'item',
                        icon: 'minus',
                        url: 'informationBlocks/index'
                    }
                ]
            },
            {
                id: 'paymentCredits-index',
                title: 'Crédito y Cobranza',
                translate: 'MENU.PAYMENT_CREDITS',
                type: 'collapsible',
                icon: '',
                newIcon: 'icon_payment_credit',
                heightIcon: 25,
                hidden: !this._permissionService.checkPermission({name: 'paymentCredit.paymentCredits.read'}),
                children: [
                    {
                        id: 'counted-index',
                        title: 'Créditos y Contados',
                        translate: 'MENU.CREDIT_COUNTED',
                        type: 'item',
                        icon: 'minus',
                        url: 'payment/credits/creditCounted/index',
                        hidden: true
                    },
                    {
                        id: 'receivable-index',
                        title: 'Por Cobrar',
                        translate: 'MENU.RECEIVABLE',
                        type: 'item',
                        icon: 'minus',
                        url: 'payment/credits/receivable/index',
                        hidden: true
                    },
                    {
                        id: 'accounts-receivable-index',
                        title: 'Cuentas por Cobrar',
                        translate: 'MENU.ACCOUNTS_RECEIVABLE',
                        type: 'item',
                        icon: 'minus',
                        url: 'payment/credits/accounts/receivable/index'
                    },
                    {
                        id: 'transaction-counted-index',
                        title: 'Contados',
                        translate: 'MENU.COUNTED',
                        type: 'item',
                        icon: 'minus',
                        url: 'payment/credits/transaction/counted/index'
                    },
                    {
                        id: 'transaction-credits-index',
                        title: 'Créditos',
                        translate: 'MENU.CREDITS',
                        type: 'item',
                        icon: 'minus',
                        url: 'payment/credits/transaction/credits/index'
                    }
                ]
            },
            {
                id: 'liquidations-index',
                translate: 'MENU.LIQUIDATIONS',
                title: 'Liquidaciones',
                type: 'item',
                icon: '',
                newIcon: 'icon_liquidation',
                url: 'liquidations/index',
                hidden: !this._permissionService.checkPermission({name: 'liquidation.liquidations.read'})
            },
            {
                id: 'banks-index',
                translate: 'MENU.BANKS',
                title: 'Bancos',
                type: 'item',
                icon: '',
                newIcon: 'icon_bank',
                url: 'banks/index',
                hidden: !this._permissionService.checkPermission({name: 'bank.banks.read'})
            },
            {
                id: 'attentionCustomers-index',
                translate: 'MENU.ATTENTION_CUSTOMERS',
                title: 'Atención a Clientes',
                type: 'item',
                icon: '',
                newIcon: 'icon_attention_customer',
                url: 'attentionCustomers/index',
                hidden: !this._permissionService.checkPermission({name: 'consignmentNote.attentionCustomers.read'})
            },
            {
                id: 'remissions-index',
                translate: 'MENU.REMISSIONS',
                title: 'Remisiones',
                type: 'item',
                icon: '',
                newIcon: 'icon_remission',
                heightIcon: 25,
                url: 'remissions/index',
                hidden: !this._permissionService.checkPermission({name: 'remission.remissions.read'})
            },
            {
                id: 'invoices-index',
                translate: 'MENU.INVOICES',
                title: 'Facturación 4.0',
                type: 'item',
                icon: '',
                newIcon: 'icon_invoice',
                heightIcon: 25,
                url: 'invoices/index',
                hidden: !this._permissionService.checkPermission({name: 'invoice.invoices.read'})
            },
            {
                id: 'debitNotes-index',
                translate: 'MENU.DEBIT_NOTES',
                title: 'Notas de Débito',
                type: 'item',
                icon: '',
                newIcon: 'icon_debit_note',
                url: 'debitNotes/index',
                hidden: !this._permissionService.checkPermission({name: 'debitNote.debitNotes.read'})
            },
            {
                id: 'complements-index',
                translate: 'MENU.COMPLEMENTS',
                title: 'Complementos',
                type: 'item',
                icon: '',
                newIcon: 'icon_complement',
                url: 'complements/index',
                hidden: !this._permissionService.checkPermission({name: 'complement.complements.read'})
            },
            {
                id: 'creditNotes-index',
                translate: 'MENU.CREDIT_NOTES',
                title: 'Notas de Crédito',
                type: 'item',
                icon: '',
                newIcon: 'icon_credit_note',
                url: 'creditNotes/index',
                hidden: !this._permissionService.checkPermission({name: 'creditNote.creditNotes.read'})
            },
            {
                id: 'catalogs',
                title: 'Catálogos',
                translate: 'MENU.CATALOGS',
                type: 'collapsible',
                icon: '',
                newIcon: 'icon_catalog',
                heightIcon: 25,
                hidden: !this._permissionService.checkPermission({name: 'common.branchOffices.read'})
                    && !this._permissionService.checkPermission({name: 'provider.providers.read'})
                    && !this._permissionService.checkPermission({name: 'operator.operators.read'})
                    && !this._permissionService.checkPermission({name: 'person.persons.read'})
                    && !this._permissionService.checkPermission({name: 'trailer.trailers.read'})
                    && !this._permissionService.checkPermission({name: 'truck.trucks.read'})
                    && !this._permissionService.checkPermission({name: 'product.products.read'})
                    && !this._permissionService.checkPermission({name: 'invoice.invoiceTypes.read'})
                    && !this._permissionService.checkPermission({name: 'common.catalogs.read'}),
                children: [
                    {
                        id: 'branchOffices-index',
                        translate: 'MENU.BRANCH_OFFICES',
                        title: 'Sucursales',
                        type: 'item',
                        icon: '',
                        newIcon: 'icon_branch_office',
                        url: 'branchOffices/index',
                        hidden: !this._permissionService.checkPermission({name: 'common.branchOffices.read'})
                    },
                    {
                        id: 'providers-index',
                        translate: 'MENU.PROVIDERS',
                        title: 'Permisionarios',
                        type: 'item',
                        icon: '',
                        newIcon: 'icon_provider',
                        url: 'providers/index',
                        hidden: !this._permissionService.checkPermission({name: 'provider.providers.read'})
                    },
                    {
                        id: 'operators-index',
                        translate: 'MENU.OPERATORS',
                        title: 'Operadores',
                        type: 'item',
                        icon: '',
                        newIcon: 'icon_operator',
                        url: 'operators/index',
                        hidden: !this._permissionService.checkPermission({name: 'operator.operators.read'})
                    },
                    {
                        id: 'customers-index',
                        translate: 'MENU.CUSTOMERS',
                        title: 'Clientes',
                        type: 'item',
                        icon: '',
                        newIcon: 'icon_customer',
                        url: 'customers/index',
                        hidden: !this._permissionService.checkPermission({name: 'customer.customers.read'})
                    },
                    {
                        id: 'persons-index',
                        translate: 'MENU.PERSONS',
                        title: 'Rems / Dests',
                        type: 'item',
                        icon: '',
                        newIcon: 'icon_person',
                        url: 'persons/index',
                        hidden: !this._permissionService.checkPermission({name: 'person.persons.read'})
                    },
                    {
                        id: 'trailers-index',
                        translate: 'MENU.TRAILERS',
                        title: 'Remolques',
                        type: 'item',
                        icon: '',
                        newIcon: 'icon_trailer',
                        url: 'trailers/index',
                        hidden: !this._permissionService.checkPermission({name: 'trailer.trailers.read'})
                    },
                    {
                        id: 'trucks-index',
                        translate: 'MENU.TRUCKS',
                        title: 'Unidades',
                        type: 'item',
                        icon: '',
                        newIcon: 'icon_truck',
                        url: 'trucks/index',
                        hidden: !this._permissionService.checkPermission({name: 'truck.trucks.read'})
                    },
                    {
                        id: 'products-index',
                        translate: 'MENU.PRODUCTS',
                        title: 'Productos',
                        type: 'item',
                        icon: '',
                        newIcon: 'icon_product',
                        url: 'products/index',
                        hidden: !this._permissionService.checkPermission({name: 'product.products.read'})
                    },
                    {
                        id: 'invoiceTypes-index',
                        translate: 'MENU.INVOICE_TYPE',
                        title: 'Tipo Factura',
                        type: 'item',
                        icon: '',
                        newIcon: 'icon_invoice_type',
                        url: 'invoices/types/index',
                        hidden: !this._permissionService.checkPermission({name: 'invoice.invoiceTypes.read'})
                    },
                    {
                        id: 'catalogs-index',
                        translate: 'MENU.CATALOGUE',
                        title: 'Claves SAT',
                        type: 'item',
                        icon: '',
                        newIcon: 'icon_catalogue',
                        url: 'catalogs/index',
                        hidden: !this._permissionService.checkPermission({name: 'common.catalogs.read'})
                    }
                ]
            },
            {
                id: 'localTravels-index',
                translate: 'MENU.LOCAL_TRAVELS',
                title: 'Viajes locales',
                type: 'item',
                icon: '',
                newIcon: 'icon_local_travel',
                url: 'localTravels/index',
                hidden: !this._permissionService.checkPermission({name: 'travel.travels.read'})
            },
            {
                id: 'foreingTravels-index',
                translate: 'MENU.FOREIGN_TRAVELS',
                title: 'Viajes foráneos',
                type: 'item',
                icon: '',
                newIcon: 'icon_local_travel',
                url: 'foreingTravels/index',
                hidden: !this._permissionService.checkPermission({name: 'travel.travels.read'})
            },
            {
                id: 'user-index',
                title: 'Usuarios',
                translate: 'MENU.USERS',
                type: 'item',
                icon: '',
                newIcon: 'icon_user',
                heightIcon: 25,
                url: 'users/index',
                hidden: !this._permissionService.checkPermission({name: 'user.users.read'})
            },
            {
                id: 'role-index',
                title: 'Roles',
                translate: 'MENU.ROLES',
                type: 'item',
                icon: '',
                newIcon: 'icon_role',
                heightIcon: 25,
                url: 'roles/index',
                hidden: !this._permissionService.checkPermission({name: 'user.roles.read'})
            },
            {
                id: 'configuration',
                title: 'Configuraciones',
                translate: 'MENU.CONFIGURATIONS',
                type: 'item',
                icon: '',
                newIcon: 'icon_configuration',
                heightIcon: 25,
                url: 'configurations',
                hidden: !this._permissionService.checkPermission({name: 'configuration.configurations.read'})
            }
        ];

        return this.menu;
    }
}
